/**
 * LotoBase
 */

class LotoBase {

    constructor( lotoCateg, dataObject ) {

        this.categ = lotoCateg;
        this.dataObj = dataObject;

        this.poolDefArray = LotoBase.makeFillSortArray( this.categ.numb, 1);

        let poteCoeff = Math.round(dataObject.nomi.pote[0][1]/5*4);
        this.nomiDataPool = new NomiDataPool(this.categ, this.dataObj.nomi, this.poolDefArray, poteCoeff );
        
        //  selectCount
        this.jyoSelectMaxCount = 2;
        this.jikuSelectMaxCount = 3;

        this.nomiContListPickupCount = 100;
    };

    
    getNomiDataPoolSelectCount() {
        return this.nomiDataPool.userJikuContList.length+this.nomiDataPool.userJyogaiContList.length;
    };


    makeNomiContents(nomiCateg, valList) {
        return new NomiContents( this.categ, nomiCateg, valList, this );
    };


    makeBooArray( nomiContents ) {

        const nomiCateg = nomiContents.nomiCateg;
        const val = nomiContents.valArray;

        const resultArray = this.dataObj.result;

        const booArray = [];
        if(nomiCateg.name==="jiku") {
            resultArray.forEach( e => booArray.push( e.hon.some( e1 =>  val.some( ev => ev===e1 ) ) ) );
        }else {
            resultArray.forEach( e => booArray.push( e.hon.every( e1 => val.every( ev => ev!==e1 ) ) ) );
        };
        return booArray;
    };



    getUserChoiceMaterial(targetCount, sortProcess=LotoBase.contArraySortProcess) {

        const nomiJyoListSize = this.nomiDataPool.getUserContListValueArrayAll(nominateCategory.JYOGAI).length;

        if(this.nomiDataPool.userJyogaiContList.length < this.jyoSelectMaxCount
        && this.categ.numb>nomiJyoListSize+targetCount+2) {
            
            return this.makeUserChoiceJyogaiMaterial( sortProcess );

        }else if(this.nomiDataPool.userJikuContList.length < this.jikuSelectMaxCount) {

            return this.makeUserChoiceJikuMaterial( sortProcess );
        }else {
            return null;
        };

    };

    makeUserChoiceJyogaiMaterial( sortProcess=LotoBase.contArraySortProcess ) {

        let poolArray = [];
        this.nomiDataPool.dataNomiUserObj.pote.forEach( e => poolArray.push(e[0]) );
        poolArray = poolArray.filter( e => ! this.nomiDataPool.checkBoxJikuList.some( e1 => e1.valArray.some( e2 => e===e2 )) );

        let covArray = [];
        LotoBase.coveringCountProcess( covArray, poolArray, 2 );

        // LotoBase.arrayRandomPickup( covArray, this.nomiContListPickupCount );    //  random pickup
        const pickupCount = covArray.length>this.nomiContListPickupCount ? this.nomiContListPickupCount : covArray.length;
        covArray = MyUtility.randomPickupArray( covArray, pickupCount );

        let contArray = [];
        covArray.forEach( val => contArray.push( new NomiContents( this.categ, nominateCategory.JYOGAI, val, this ) ) );

        contArray.sort(sortProcess);

        return contArray;
    };

    makeUserChoiceJikuMaterial( sortProcess=LotoBase.contArraySortProcess ) {

        let dataJyo = this.nomiDataPool.dataNomiUserObj.jyo;
        let hon = this.categ.hon;
        let dataJyo2 = dataJyo.slice(0,hon);
        let resultJyo = [];
        LotoBase.coveringCountProcess(resultJyo, dataJyo2, hon-2);
        //
        let dataPote = this.nomiDataPool.dataNomiUserObj.pote;
        let dataPote2 = [];
        dataPote.slice(0,12).forEach( e => dataPote2.push(e[0]) );
        
        if(this.nomiDataPool.userJikuContList.length !== 0) {
            let jikuArr = this.nomiDataPool.getUserContListValueArrayAll(nominateCategory.JIKU);
            dataPote2 = dataPote2.filter( e => ! jikuArr.some( e1 => e===e1) );
        };
        let resultPote = [];
        LotoBase.coveringCountProcess(resultPote, dataPote2, 2);

        let resultAll = [];
        resultJyo.forEach( e => resultPote.forEach( e1 => resultAll.push( e.concat(e1) ) ) );

        //resultAll = LotoBase.arrayRandomPickup( resultAll, this.nomiContListPickupCount );    //  random pickup
        const pickupCount = resultAll.length>this.nomiContListPickupCount ? this.nomiContListPickupCount : resultAll.length;
        resultAll = MyUtility.randomPickupArray( resultAll, pickupCount );

        let contArray = [];
        resultAll.forEach( val => contArray.push( new NomiContents( this.categ, nominateCategory.JIKU, val, this ) ) );

        contArray.sort(sortProcess);

        return contArray;
    };


    //  addContents
    nomiDataPoolAddUserChoiceContents(cont) {

        if( nominateCategory.equals( cont.nomiCateg, nominateCategory.JYOGAI ) ) {
            this.nomiDataPool.nomiUserObjAddJyoCont(cont);
        }else {
            this.nomiDataPool.nomiUserObjAddJikuCont(cont);
        };
    };

    // reset
    nomiDataPoolResetAll() {
        this.nomiDataPool.nomiDataPoolResetAll();
    };

    nomiDataPoolUserContListReset() {
        this.nomiDataPool.nomiUserObjReset();
    };

    
    // pop
    nomiDataPoolUserContListPop() {
        return this.nomiDataPool.nomiUserContListPop();
    };

    //  next Result
    getResultNumber( targetCount ) {

        return this.nomiDataPool.makeResultNumber( targetCount );
    };



    //
    //  static method
    //

    static makeFillSortArray(size, firstNumb) {

        let result = [];
        for(let i=0; i<size; i++) {   result.push( i+firstNumb );   };
        return result;
    };

    static makeRemoveValArray(targetArray, removeArray) {

        return targetArray.filter( val => ! removeArray.some( e => e===val) );
    };

    //  sort filter
    static contArraySortProcess( val1, val2) {

        let ct1 = LotoBase.arrayBooCount(val1.booArray, 10, 10); 
        let ct2 = LotoBase.arrayBooCount(val2.booArray, 10, 10);
    
        return ct2-ct1;
    };
    
    //  random pickup
    /*
    static arrayRandomPickup( array, size ) {

        let result =[];
        let len = array.length;
        if(array.length<=size) {
            array.forEach(  e => result.push(e) );
        }else {
            if(array.length/2 > size) {
                let indBooArr = MyUtility.makeFillArray( array.length, false );
                for(let i=0; i<size; i++) {
                    let ind = Math.floor( Math.random()*len );
                    while( true ) {
                        if( indBooArr[ind] ) {
                            ind = Math.floor( Math.random()*len );
                        }else {
                            indBooArr[ind] = true;
                            break;
                        };
                    };
                };
                result = array.filter( (val, ind) => indBooArr[ind] );
            }else {
                size = array.length-size;
                let indBooArr = MyUtility.makeFillArray( array.length, true );
                for(let i=0; i<size; i++) {
                    let ind = Math.floor( Math.random()*len );
                    while( true ) {
                        if( ! indBooArr[ind] ) {
                            ind = Math.floor( Math.random()*len );
                        }else {
                            indBooArr[ind] = false;
                            break;
                        };
                    };
                };
                result = array.filter( (val, ind) => indBooArr[ind] );
            };
        };
        return result;
    };
    */


    /**
     * 第一引数のboolean配列のtrueの数をカウント。
     * 最後尾要素から第二引数分さかのぼった要素から、第三引数分の間の要素を対象範囲とする
     * 例：booArray.length=100, lste=10, size=5 の場合、要素番号９０～９４まで。
     * @param {} booArray 
     * @param {*} late 
     * @param {*} size 
     */
    static arrayBooCount(booArray, late, size) {
        if(size<=0) { return 0; };
        size = late<size ? late : size;
        let boo = booArray.slice(booArray.length-late, booArray.length-late+size);
        return boo.filter( val => val ).length;
    };




    static getNomiContensPercent(  lotoCateg, nomiCateg, valArray  ) {

        const generalCount = this.lotoCateg_generalCount( lotoCateg );
        const nomiCount = this.lotoCateg_SelectCoveringCount( lotoCateg, nomiCateg, valArray );

        return nomiCount/generalCount;
    };

    /**
     * 各Lotoのカテゴリーごとの組み合わせ総数
     * @param {*} lotoCategObj 
     */
    static lotoCateg_generalCount(lotoCategObj) {

        const numb = lotoCategObj.numb;
        const hon = lotoCategObj.hon;

        return LotoBase.poolInNumberGeneralCount( numb, hon );
    };


    /**
     * 引数(各lotocategory,各Nominatecategory,選択数字数)　ごとのパターン総数
     * @param {} lotoCategObj 
     * @param {*} nomiCategObj 
     * @param {*} selectArray 
     */
    static lotoCateg_SelectCoveringCount( lotoCategObj, nomiCategObj, selectArray ) {

        const numb = lotoCategObj.numb;
        const hon = lotoCategObj.hon;
        const selectCount = selectArray.length;

        if(nomiCategObj.name==="jiku") {
            return LotoBase.poolInNumber_fukujikuCount( numb, hon, selectCount);
        }else {
            return LotoBase.poolInNumberGeneralCount( numb-selectCount, hon );
        };
        
    };



    // general method
    //

    /**
     * 網羅的並べ替えを再帰呼び出しで処理
     * @param {*} resultArray 結果を格納する配列
     * @param {*} poolArray 並べ替え対象配列
     * @param {*} loopNumb 並べ替え個数
     * @param {*} isMax true＝loopNumb個数まですべて、false＝loopNumb個数だけ
     * @param {*} ofs 当関数内で使うパラメータ
     * @param {*} loopNow 当関数内で使うパラメータ
     * @param {*} array 当関数内で使うパラメータ
     */
    static coveringCountProcess(resultArray, poolArray, loopNumb, isMax=false, loopNow=0, ofs=0, array=[]) {

		if(loopNow<loopNumb) {
			let loopNow_t = loopNow+1;
			for(let i=ofs, n=poolArray.length; i<n; i++) {
				let ofs_t = i+1;
				let arrayInn = MyUtility.copyArray(array);
				arrayInn.push(poolArray[i]);
				if(isMax) {
					resultArray.push(arrayInn);
				}else if( loopNow_t==loopNumb ) {
					resultArray.push(arrayInn);
				};
				LotoBase.coveringCountProcess( resultArray, poolArray, loopNumb, isMax, loopNow_t, ofs_t, arrayInn );
			};
        };
    };


    /**
     * 第一引数の数の中の、第二引数の数のパターン総数、第二引数が ０ 以下の場合 1 を返す。
     * @param {*} poolNum 
     * @param {*} num 
     */
	static poolInNumberGeneralCount( poolNumb, num ) {

		let bunbo = 1,   bunsi = 1;
		for(let i=0; i<num; i++) {
			bunbo *= num-i;
			bunsi *= poolNumb-i;
		};
		return bunsi/bunbo;
    };
    

    /**
     * 例:ロトくじの場合【　poolNumb=候補数字数, hon=本数字(数), numb=複軸として選択した数字(数)　】
     * の場合のパターン総数
     * @param {} poolNumb 
     * @param {*} hon 
     * @param {*} numb 
     */
    static poolInNumber_fukujikuCount( poolNumb, hon, numb) {

        let result = 0;
        if(numb>=0 && poolNumb>=numb) {
            const forMax = numb<hon ? numb : hon;
            for(let i=1; i<=forMax; i++) {
                result += LotoBase.poolInNumberGeneralCount(numb, i)*LotoBase.poolInNumberGeneralCount(poolNumb-numb, hon-i);
            };
            result = numb==0 ? LotoBase.poolInNumberGeneralCount(poolNumb, hon) : result;
        };
        return result;
    };
    


    
    
    



    //
    //  numberAnaly
    //

    

};
